// extracted by mini-css-extract-plugin
export default {"cardLink":"Home_cardLink__HVjLq","card":"Home_card__lxMQh"};